import type { PlaidEnvironment } from '../../_types';

export const PLAID_TOKEN_QUERY_KEY = 'select-bank-modal-plaid-connect';
export const PLAID_TOKEN_QUERY_KEY_PREFIX = [PLAID_TOKEN_QUERY_KEY] as const;

export type PlaidEmbedSession = {
  environment: PlaidEnvironment;
  token: string;
};

export function getPlaidEmbedTokenQueryKey(args: {
  teamId: string | undefined;
  userId: string | undefined;
  environment: PlaidEnvironment;
}) {
  return [
    PLAID_TOKEN_QUERY_KEY,
    args.teamId ?? null,
    args.userId ?? null,
    args.environment,
  ] as const;
}

export function shouldEnablePlaidEmbedTokenQuery(args: {
  opened: boolean;
  teamId: string | undefined;
  userId: string | undefined;
}) {
  return args.opened && !!args.teamId && !!args.userId;
}

export function getNextPlaidEmbedSession(args: {
  opened: boolean;
  currentSession: PlaidEmbedSession | null;
  nextToken: string | null;
  environment: PlaidEnvironment;
}) {
  if (!args.opened) {
    return null;
  }

  if (args.currentSession) {
    return args.currentSession;
  }

  if (!args.nextToken) {
    return null;
  }

  return {
    environment: args.environment,
    token: args.nextToken,
  } satisfies PlaidEmbedSession;
}
